module.exports = __webpack_public_path__ + "img/asset-active.f4f5d1a5.svg";